// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3eKi3","vLegacy":"SelectSecondary_vLegacy__24gPn","error":"SelectSecondary_error__O7w58","disabled":"SelectSecondary_disabled___Jrno"};